import { type Nil, isNil, isNumber, isString, isBoolean } from "@mcwd/typescript-type-guards";
import { parseBool } from "./parseBool.js";



export function parseNumber (value: unknown, { parseFromBoolean = false } = {}): number | Nil
{
  if (isNil(value) || isNumber(value))
  {
    return value;
  }
  if (isString(value))
  {
    const val = Number(value);
    if (!Number.isNaN(val))
    {
      return val;
    }
    value = parseFromBoolean ? parseBool(value) : value;
  }
  if (parseFromBoolean && isBoolean(value))
  {
    return Number(value);
  }
  return null;
}
